export default __webpack_public_path__ + "static/media/phone.8ba0835f.svg";